import { $el } from 'src/scripts/utils/utils'
import { ModalButton } from '../../components/modal/modal-button'
import { ProductModal } from './product-modal'

export class ProductModalButton extends ModalButton {
  trigger(): void {
    const modal: ProductModal = $el(this.dataset.modal)

    if (this.dataset.action === 'open' && modal) {
      // Product Modal 需要在一次 show 生命周期中定位到对应媒体，不能先走基类 show。
      void modal.openAndShowMediaById(this.dataset.mediaId, this)
      return
    }

    super.trigger()
  }
}
